import { TAGS } from "../constants";
import { PharmacyPatient } from "../types";
import { patientApi } from "./patientsApi";

const dosespotPatient = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getDosespotPatient: builder.query<PharmacyPatient, number>({
      query: (patientId) => ({
        url: `/api/pharmacy-patients/${patientId}`,
        method: "GET",
        params: {
          service_name: "Dosespot",
        },
      }),
      providesTags: (_result, _error, arg) => [
        { type: TAGS.DOSESPOT_PATIENT, id: arg },
      ],
    }),
  }),
});

export const { useGetDosespotPatientQuery } = dosespotPatient;
